import { createAction, props } from '@ngrx/store';
import { aris360DetailPayload, aris360ListPayload } from './aris360.model';

export const fetchAris360List = createAction('[Data] Fetch Aris360 List', props<{ payload: aris360ListPayload }>());
export const fetchAris360ListSuccess = createAction('[Data] Fetch Aris360 List Success', props<{ response: any }>());
export const fetchAris360ListFailure = createAction('[Data] Fetch Aris360 List Failure', props<{ error: string }>());

export const fetchAris360Detail = createAction('[Data] Fetch Aris360 Detail', props<{ payload: aris360DetailPayload }>());
export const fetchAris360DetailSuccess = createAction('[Data] Fetch Aris360 Detail Success', props<{ response: any }>());
export const fetchAris360DetailFailure = createAction('[Data] Fetch Aris360 Detail Failure', props<{ error: string }>());

export const assignAgent = createAction('[Data] Assign Agent', props<{ payload: any }>());
export const assignAgentSuccess = createAction('[Data] Assign Agent Success', props<{ response: any }>());
export const assignAgentFailure = createAction('[Data] Assign Agent Failure', props<{ error: string }>());
